var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"career-page"},[_c('div',{staticClass:"max-w-small"},[_c('div',{ref:"iframeApp",attrs:{"id":"grnhse_app"}},[_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"icon-spinner"})])
}]

export { render, staticRenderFns }